module.exports = __webpack_public_path__ + "img/PMS_BDO.09177821.gif";